import { render, staticRenderFns } from "./RetailStockTransfers.vue?vue&type=template&id=0cab2f1f"
import script from "./RetailStockTransfers.vue?vue&type=script&lang=js"
export * from "./RetailStockTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports